import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useStores } from '@trivie/core'
import { TableHelper } from '../../../../tables'
import { useRouteMatch } from 'react-router-dom'
import { QuizTable } from '../../../../tables/quiz-table'

const Quizzes: React.FunctionComponent = observer(() => {
  const { tagStore } = useStores()
  const { selectedTagId, setSelectedTagId } = tagStore

  const match = useRouteMatch<any>('/people/tags/:id/quizzes')
  const tagID = Number(match?.params.id)

  const [tableHelper] = useState(new TableHelper('list_tag_quizzes', 'quizzes', 'tags', tagID))

  useEffect(() => {
    if (!selectedTagId) {
      setSelectedTagId(tagID)
    }
  }, [])

  return <QuizTable tableHelper={tableHelper} />
})

export const TagsQuizzesTab = (props: any) => {
  const { id } = props
  return {
    name: 'Quizzes',
    path: `/people/tags/${id}/quizzes`,
    component: () => <Quizzes />,
  }
}
